import 'css-chunksrc/client/scenes/project/managerList/styles.scss';export default {
  "resourceList": "_resourceList_q6vpy_1",
  "list": "_list_q6vpy_8",
  "buttonWrapper": "_buttonWrapper_q6vpy_17",
  "resources": "_resources_q6vpy_23",
  "hiddenTagsNbr": "_hiddenTagsNbr_q6vpy_31",
  "form": "_form_q6vpy_46",
  "icon": "_icon_q6vpy_54"
};